export function setDirectionScheme(language) {
  if (language == 'ar' || language == 'uae') {
    document.documentElement.style.setProperty('--right-alignment', 'right');
    document.documentElement.style.setProperty('--direction', 'rtl');
    document.body.setAttribute('dir', 'rtl');
  } else {
    document.documentElement.style.setProperty('--right-alignment', 'unset');
    document.documentElement.style.setProperty('--direction', 'unset');
    document.body.setAttribute('dir', 'ltr');
  }
}
